import { render, staticRenderFns } from "./ResidentialAccounts.vue?vue&type=template&id=3cd2a21b"
import script from "./ResidentialAccounts.vue?vue&type=script&lang=js"
export * from "./ResidentialAccounts.vue?vue&type=script&lang=js"
import style0 from "./ResidentialAccounts.vue?vue&type=style&index=0&id=3cd2a21b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports